// A line or two about your covert ops, and about ops done to you.
import { type OpLogEntry, opMessageKey, opOther, opTone } from '../espionage/opNews.js';
import { useT } from '../i18n/index.js';

const TONE = {
  good: 'border-emerald-500/50 text-emerald-700 dark:text-emerald-300',
  bad: 'border-red-500/50 text-red-700 dark:text-red-300',
  neutral: 'border-border text-foreground',
} as const;

export function OpNotices({
  entries,
  nameOf,
}: {
  readonly entries: readonly OpLogEntry[];
  readonly nameOf: (seat: number) => string;
}) {
  const t = useT();
  if (entries.length === 0) return null;
  return (
    <div className="flex w-full flex-col items-center gap-1.5" data-testid="op-notices">
      {entries.map((e) => {
        const other = opOther(e);
        return (
          <div
            key={e.id}
            className={`animate-notice-fade pointer-events-auto w-full max-w-[min(92vw,460px)] rounded-lg border bg-panel-scrim px-3 py-1.5 text-sm backdrop-blur-sm ${TONE[opTone(e)]}`}
          >
            {t(opMessageKey(e), { house: other === null ? '' : nameOf(other) })}
          </div>
        );
      })}
    </div>
  );
}
